<label
  class="fld"
  appSisFieldLoading
  [loading]="loading"
  [loadedKey]="loadedKey"
  [loadedMessage]="loadedMessage"
  [loadFailed]="loadFailed"
  [class.ok]="visualState === 'ok'"
  [class.err]="visualState === 'err'"
  [attr.data-disabled]="isLockedOrDisabled || null">
  <span class="lab">{{ label }}</span>
  <span class="inp">
    <input
      [id]="inputId"
      [type]="type"
      [value]="inputValue"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabled]="isLockedOrDisabled"
      [attr.min]="min"
      [attr.max]="max"
      [attr.maxlength]="maxlength"
      [attr.aria-invalid]="error ? 'true' : null"
      [attr.aria-describedby]="describedBy"
      (input)="onInput($event)"
      (blur)="onBlur()">
    <span class="ico ico-check" *ngIf="visualState === 'ok' || icon === 'check'" aria-hidden="true"></span>
    <span *ngIf="loadFailed" class="ico ico-alert" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13A6.5 6.5 0 0 0 8 1.5ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4.5Zm0 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/>
      </svg>
    </span>
  </span>
  <ng-container *ngIf="loadFailed; else normalHelper">
    <span class="help load-failed" [id]="inputId + '-helper'">
      {{ failedText }}
      <ng-container *ngIf="showRetry">
        &nbsp;
        <button
          type="button"
          class="btn-retry"
          [attr.aria-label]="'Reintentar carga de ' + label"
          (click)="retryLoad.emit(); $event.preventDefault()">
          Reintentar
        </button>
      </ng-container>
    </span>
  </ng-container>
  <ng-template #normalHelper>
    <span *ngIf="helperText" class="help" [id]="error ? inputId + '-error' : inputId + '-helper'">{{ helperText }}</span>
  </ng-template>
</label>
